import script from "./Main.vue?vue&type=script&setup=true&lang=ts"
export * from "./Main.vue?vue&type=script&setup=true&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=79b257e4&lang=css"

const __exports__ = script;

export default __exports__